import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: null,
    returns: [],
    summary: {
      totalReturnAmount: 0,
      totalReturnCount: 0,
      totalInvoiceCount: 0,
      dateRange: {
        start: null,
        end: null,
        frequency: "monthly"
      }
    }
  },
  loading: false,
  error: null,
};

const returnTrendReportSlice = createSlice({
  name: "returnTrendReport",
  initialState,
  reducers: {
    returnTrendReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    returnTrendReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    returnTrendReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetReturnTrendReport(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    },
  },
});

export const {
  returnTrendReportRequest,
  returnTrendReportSuccess,
  returnTrendReportFailure,
  resetReturnTrendReport,
} = returnTrendReportSlice.actions;

export default returnTrendReportSlice.reducer;